<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		findConpanyConfig
	} from '../../../../../../api/Draftgeneration.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				// tableDataI: getdata().tableDataI,
				delCells: [],
				option: getdata().option,
			};
		},
		props: {
			params: {
				type: Object,
				default: {}
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: []
			},
			optionxfs: {
				type: Array,
				default: []
			},
			headobj: {
				type: Object,
				default: {}
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			changeXfs(e, ve, index) {
				optionxdansha(this.optionxfs)

				function optionxdansha(data) {
					ve['xfs_3_x_1'].cellType = '1'
					data.forEach(item => {
						if (item.value == e) {
							if (item.type == '1') {
								ve['xfs_3_x_5'].cellVal = (parseFloat(item.shuil) * 100).toString()
								ve['xfs_3_x_7'].cellVal = '0'
								ve['xfs_3_x_6'].cellVal = '0'
							} else if (item.type == '2') {
								ve['xfs_3_x_7'].cellVal = (item.shuil).toString()
								ve['xfs_3_x_5'].cellVal = '0'
								ve['xfs_3_x_4'].cellVal = '0'
							}

						} else {
							if (item.children) {
								optionxdansha(item.children)
							}
						}
					})
				}
				this.$emit('forhover', 'tableDataIII_I', 'xfs_3_x_5', index);
				this.$emit('inputblur', ve['xfs_3_x_5']);
				this.$emit('forhover', 'tableDataIII_I', 'xfs_3_x_7', index);
				this.$emit('inputblur', ve['xfs_3_x_7']);
				this.$emit('forhover', 'tableDataIII_I', 'xfs_3_x_1', index);
			},
			selectchangetwo(e) {
				e['xfs_3_x_2.1'].cellType = '1'
				e['xfs_3_x_2.2'].cellType = '1'
				e['xfs_3_x_3.1'].cellType = '1'
				e['xfs_3_x_3.2'].cellType = '1'
				//减免性质代码
				// e['xfs_3_x_2.1'].cellVal = e['xfs_3_x_2.1'].cellVal
				//减免性质名称
				e['xfs_3_x_2.2'].cellVal = (this.option.filter(v => v.value == e['xfs_3_x_2.1'].cellVal)[0].label).split(
					'|')[3]
				//税务事项代码
				e['xfs_3_x_3.1'].cellVal = (this.option.filter(v => v.value == e['xfs_3_x_2.1'].cellVal)[0].label).split(
					'|')[1]
				//税务事项名称
				e['xfs_3_x_3.2'].cellVal = (this.option.filter(v => v.value == e['xfs_3_x_2.1'].cellVal)[0].label).split(
					'|')[2]
			},
			headchange() {
				this.$emit('headchange', this.headobj);
			},
			inputblur(e) {
				this.$emit('inputblur', e);
			},
			forhover(table, colum, index) {
				this.$emit('forhover', table, colum, index);
			},
			zcsclick(e) {
				this.$emit('zcsclick', e);
			},
			fordelete(index) {
				if (this.tableDataI.length < 3) {
					return false;
				}
				if (this.$notemptyandnull(this.tableDataI[index]['xfs_3_x_1'].id)) {
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
				}
				this.tableDataI.splice(index, 1);
				this.$emit('delCellsCode', this.delCells, 'IIIHead');
			},
			foraddhang() {
				let hanh = this.tableDataI.length - 1
				this.tableDataI.splice(this.tableDataI.length - 1, 0, {
					hanh: hanh,
					"xfs_3_x_1": {
						cellCode: "xfs_3_" + hanh + "_1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_2.1": {
						cellCode: "xfs_3_" + hanh + "_2.1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_2.2": {
						cellCode: "xfs_3_" + hanh + "_2.2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_3.1": {
						cellCode: "xfs_3_" + hanh + "_3.1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_3.2": {
						cellCode: "xfs_3_" + hanh + "_3.2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_4": {
						cellCode: "xfs_3_" + hanh + "_4",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_5": {
						cellCode: "xfs_3_" + hanh + "_5",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_6": {
						cellCode: "xfs_3_" + hanh + "_6",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_7": {
						cellCode: "xfs_3_" + hanh + "_7",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_3_x_8": {
						cellCode: "xfs_3_" + hanh + "_8",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},

				})
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>